import { ExportProgress as ProgressState } from '../../utils/csvExportTypes'
import { cn } from '../../shared/utils/cn'

interface ExportProgressProps {
  progress: ProgressState
}

export function ExportProgress({ progress }: ExportProgressProps) {
  const percentage = progress.total > 0
    ? Math.round((progress.current / progress.total) * 100)
    : 0

  const phaseLabels: Record<ProgressState['phase'], string> = {
    preparing: 'Preparing...',
    processing: 'Processing data...',
    generating: 'Generating CSV...',
    complete: 'Complete!'
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className="text-gray-600">{phaseLabels[progress.phase]}</span>
        <span className="text-gray-500">{percentage}%</span>
      </div>

      {/* Progress Bar */}
      <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className={cn(
            'h-full transition-all duration-300 ease-out',
            progress.phase === 'complete' ? 'bg-green-500' : 'bg-blue-500'
          )}
          style={{ width: `${percentage}%` }}
        />
      </div>

      <p className="text-xs text-gray-500">{progress.message}</p>
    </div>
  )
}
